/* tslint:disable */
/* eslint-disable */
export enum MaritalStatusEnum {
  Single = 'Single',
  Married = 'Married',
  DeFacto = 'DeFacto',
  Widowed = 'Widowed'
}
